import PageWrapper from "app/modules/shared/PageWrapper";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import Dashboard from "./Dashboard";
import { ClientPortalWebNarratives } from "cpl-react-common/components/Enums/ClientPortalWebNarratives";

const DashboardPage = () => {
  return (
    <CPLAnalytics pageName="Client Portal Dashboard">
      <PageWrapper title="Dashboard" webNarrativeID={ClientPortalWebNarratives.Dashboard} hideBackButton>
        <Dashboard />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default DashboardPage;
